import React from 'react'
import InputGroup from '../../../../UI/Forms/InputGroup/InputGroup'
import classes from './Form.scss'

const form = ({ form, inputChanged }) => {
  let inputgroup = Object.entries(form).map(res => {
    let [key, attr] = res

    return (
      <InputGroup
        key={key}
        label={attr.label}
        inputType={attr.elementType}
        configs={attr.elementConfig}
        invalid={!attr.valid}
        validations={attr.validation}
        touched={attr.touched}
        changed={e => inputChanged(key, e)}
        inputValue={attr.value}
        validationError={attr.error}
      />
    )
  })

  return <div className={classes.Form}>{inputgroup}</div>
}

export default form
